import constants from "../../../../../../appConstants";
import {
  mergeUserConfig,
  formatDateTimeWithoutUTCConversion,
} from '@dataGrid/gridUtilities';
import {
  MultiSelectFilter,
  DateTimeFilter,
  StaticFilter,
} from '@dataGrid/components/columnFilters';
import DefectsDetails from "../../Defects/DefectsDetails";
import {
  defectsFilterOptions,
  getDefectsFilterValue,
} from "../../Defects/DefectsFilter";
import { getDefects, getScacValue } from "../../utils/utils";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration({ showTrailerScacColumn, showTrailerScacValue, userConfig }) {
    const defaultConfig = GridConfig.getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue);
    return mergeUserConfig({
      defaultConfig,
      userConfig,
    });
  }

  static TrailerNumberRenderer = (params) => {
    if (!params.data.trailerNumber) {
      return <span style={{ opacity: 0.5 }}>No trailer</span>;
    }
    return <span>{params.data.trailerNumber}</span>;
  };

  static ManifestNumberRenderer = (params) => {
    return (
      <span
        className="ag-cell-value"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          opacity: params.value ? 1 : 0.5,
        }}
      >
        {params.value || 'No Manifest'}
      </span>
    );
  };


  static getLocation(params) {
    return params.data.spottedDetails?.spottedAddress || null;
  }

  static getDefaultConfiguration(showTrailerScacColumn, showTrailerScacValue) {
    return {
      title: constants.gridNames.TrailersGrid,
      keyColumn: "trailerId",
      rowSelection:'single',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
      },
      columns: [
        {
          headerName: "Trailer #",
          headerTooltip: "Trailer #",
          field: "trailerNumber",
          pinned: "left",
          width: constants.columnWidth.W_110,
          minWidth: constants.columnWidth.W_110,
          cellClass: "gridCell-leftAlign",
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          cellRenderer: GridConfig.TrailerNumberRenderer,
        },
        {
          headerName: "Trailer Name",
          headerTooltip: "Trailer Name",
          field: "trailerName",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_130,
          minWidth: constants.columnWidth.W_130,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "trailerScac",
          hide: !showTrailerScacColumn,
          isInvisibleInShowHide: !showTrailerScacColumn,
          shouldForceHideColumn: !showTrailerScacColumn,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_120,
          minWidth: constants.columnWidth.W_120,
          valueGetter: getScacValue(showTrailerScacValue, 'trailerScac'),
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Class",
          headerTooltip: "Trailer Class",
          field: "trailerClass",
          filter: MultiSelectFilter,
          width: constants.columnWidth.DISPATCH_TRAILER_CLASS,
          minWidth: constants.columnWidth.DISPATCH_TRAILER_CLASS,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Trailer Status",
          headerTooltip: "Trailer Status",
          field: "trailerStatus",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_130,
          minWidth: constants.columnWidth.W_130,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Customer",
          headerTooltip: "Customer Name",
          field: "spottedDetails.customerName",
          minWidth: constants.columnWidth.CUSTOMER,
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          tooltipValueGetter: (params) => params.value,
          filterParams:{
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: "Location",
          headerTooltip: "Location",
          valueGetter: GridConfig.getLocation,
          tooltipValueGetter: (params) => params.value,
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_140,
          minWidth: constants.columnWidth.W_140,
          cellClass: "gridCell-leftAlign",
          filterParams:{
            width: constants.columnWidth.W_300
          }
        },
        {
          headerName: "Manifest #",
          headerTooltip: "Manifest #",
          field: "manifestNumber",
          width: constants.columnWidth.W_140,
          minWidth: constants.columnWidth.W_140,
          cellRenderer: GridConfig.ManifestNumberRenderer,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
          tooltipField: "manifestNumber"
        },
        {
          headerName: "Current Terminal",
          headerTooltip: "Current Terminal",
          field: "inboundTerminal",
          filter: MultiSelectFilter,
          width: constants.columnWidth.W_180,
          minWidth: constants.columnWidth.W_180,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Last Updated",
          headerTooltip: "Last Updated",
          field: "lastModifiedDateTs",
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME,
          },
          width: constants.columnWidth.W_130,
          minWidth: constants.columnWidth.W_130,
          cellClass: "gridCell-leftAlign",
          valueFormatter: formatDateTimeWithoutUTCConversion,
        },
        {
          headerName: "Defect",
          headerTooltip: "Defect",
          valueGetter: getDefects,
          cellRenderer: DefectsDetails,
          filter: StaticFilter,
          filterParams: {
            staticOptions: defectsFilterOptions,
            getValue: getDefectsFilterValue
          },
          sortable: false,
          width: constants.columnWidth.W_240,
          minWidth: constants.columnWidth.W_240,
          cellClass: "gridCell-leftAlign",
        },
      ],
    };
  }
}
